import { useAsyncCallback } from '@wix/cli-ui-kit';
import { variant } from 'variant';
import { execa } from 'execa';
import { join } from 'node:path';
import type { IPackageManager } from '@wix/package-manager';

const ReleaseStateVariant = variant({
  Success: {},
  Skipped: {},
  Error: {},
});

export const useReleaseProject = () => {
  return useAsyncCallback(
    async (
      _,
      {
        confirmed,
        packageManager,
        targetParentFolder,
        folderName,
      }: {
        confirmed: boolean;
        packageManager: IPackageManager;
        targetParentFolder: string;
        folderName: string;
      }
    ) => {
      if (!confirmed) {
        return ReleaseStateVariant.Skipped();
      }
      const packageFolder = join(targetParentFolder, folderName);

      try {
        const buildCommand = packageManager.getRunBinaryCmd(['wix', 'build']);
        const releaseCommand = packageManager.getRunBinaryCmd([
          'wix',
          'release',
        ]);

        await execa(buildCommand.file, buildCommand.args, {
          cwd: packageFolder,
          stdio: 'ignore',
        });

        await execa(releaseCommand.file, releaseCommand.args, {
          cwd: packageFolder,
          stdio: 'ignore',
        });
      } catch {
        return ReleaseStateVariant.Error();
      }

      return ReleaseStateVariant.Success();
    }
  );
};
